import { useDroppable } from '@dnd-kit/core';
import { Box, Text, useColorModeValue } from '@chakra-ui/react';

interface DriverDropZoneProps {
  id: string;
  label: string;
  children?: React.ReactNode;
  isEmpty?: boolean;
}

const DriverDropZone = ({
  id,
  label,
  children,
  isEmpty = true,
}: DriverDropZoneProps) => {
  const { isOver, setNodeRef } = useDroppable({ id });

  const borderColor = useColorModeValue('gray.300', 'whiteAlpha.200');
  const activeBorderColor = useColorModeValue('blue.400', 'blue.300');
  const activeBgColor = useColorModeValue('blue.50', 'blue.900');
  const placeholderColor = useColorModeValue('gray.400', 'gray.500');

  return (
    <Box
      ref={setNodeRef}
      minH="44px"
      p={2}
      borderWidth="2px"
      borderStyle="dashed"
      borderColor={isOver ? activeBorderColor : borderColor}
      borderRadius="md"
      bg={isOver ? activeBgColor : 'transparent'}
      transition="all 0.15s"
    >
      {isEmpty ? (
        <Text fontSize="xs" color={placeholderColor} textAlign="center" py={1}>
          {label}
        </Text>
      ) : (
        children
      )}
    </Box>
  );
};

export default DriverDropZone;
